// extracted by mini-css-extract-plugin
export var htmlPreview = "_ov-2";
export var modal = "_ov-0";
export var sidebar = "_ov-1";